import request from '../../../utils/request';
const querystring = require('querystring')
 
//获取列表数据
export const fetchData = query => {  
    
    var list = request({
        url: 'comFile/selectPage.do',
        method: 'post',
        data: querystring.stringify(query),  
    });  
    return list;
};
 
//启用-禁用 
export const changeStatus = query => {  
    var list = request({
        url: 'comFile/changeStatus.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
//添加渠道信息
export const saveForm = query => {  
    var list = request({ 
        url: 'comFile/insertBatch.do',
        headers: { 'Content-Type':  'multipart/form-data;charset=utf-8' },
        method: 'post',
        data:   query, 
    }); 
    return list;
};

export const handDelete = query => {  
    var list = request({
        url: 'comFile/delete.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
export const changeForm = query => {  
    var list = request({
        url: 'comFile/update.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};


export const fetchSelect = query => {  
    var list = request({
        url: 'comFile/getListFetch.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};


export const fetchSelect2 = query => {  
    var list = request({
        url: 'comApiwarn/getListFetch.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
